export default __webpack_public_path__ + "static/media/dummy-all-smtp-video.54e5adbe.png";